import React from "react"

export const BreadcrumbSpan = ({ content }) => {
  return (
    <div className="level-item help is-marginless">
      <p>{content}</p>
    </div>
  )
}
